/**
 * This source code is and remains the property of UserZoom Technologies Inc (sucursal en España).
 * Dissemination of this information or reproduction of this material is strictly
 * forbidden unless prior written permission is obtained from
 * UserZoom Technologies Inc (sucursal en España) (https://www.userzoom.com).
 **/

import { css, FlattenSimpleInterpolation } from 'styled-components';

const UnexpectedErrorStyles = (): FlattenSimpleInterpolation => css`
   text-align: center;
 `;

export default UnexpectedErrorStyles;
